import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Observable, BehaviorSubject } from 'rxjs';
import { CsvImportUpload } from '../../../models/csv-import.model';
import { AlertService } from '../../../../core/alert.service';
import { CsvImportService } from '../../../services/csv-import.service';

@Component({
  selector: 'app-csv-import-validation',
  templateUrl: './csv-import-validation.component.html',
  styleUrls: ['./csv-import-validation.component.scss'],
})
export class CsvImportValidationComponent implements OnInit {
  busy: boolean = false;
  uploadType: number = 1;
  uploadStep: number = 1;
  processingFile: boolean = false;

  private gridApi;
  private gridColumnApi;

  itemColumns: any[];
  customerColumns: any[];
  invoiceColumns: any[];
  columns: any[];
  importItems: any[];
  importTypeHeader: string = 'Products';

  @Input() itemsDataSource: BehaviorSubject<any[]> = new BehaviorSubject([]);

  @Input() type: string = ''; // [products,customers,invoices]

  constructor(
    private activeModal: NgbActiveModal,
    private csvImportService: CsvImportService,
    private alert: AlertService
  ) {
    this.itemsDataSource = new BehaviorSubject([]);

    this.itemColumns = [
      { headerName: 'Item Name', field: 'ItemName' },
      {
        headerName: 'Item Category',
        field: 'ItemCategory',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Item Description',
        field: 'ItemDescription',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Tax Code',
        field: 'TaxCode',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Item Unit',
        field: 'ItemUnit',
        sortable: true,
        filter: true,
      },
      { headerName: 'SKU', field: 'SKU', sortable: true, filter: true },
      { headerName: 'Price', field: 'Price', sortable: true, filter: true },
      {
        headerName: 'ImageUrl',
        field: 'ImageUrl',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Validation Result',
        field: 'MissingFieldText',
        sortable: false,
        filter: false,
        cellRenderer: this.validationRenderer.bind(this),
      },
    ];

    this.customerColumns = [
      { headerName: 'Customer Type', field: 'CustomerType' },
      {
        headerName: 'Business Name',
        field: 'BusinessName',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'FirstName',
        field: 'FirstName',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'LastName',
        field: 'LastName',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'EmailAddress',
        field: 'EmailAddress',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Birthday',
        field: 'Birthday',
        sortable: true,
        filter: true,
      },
      {
        headerName: 'Job Title',
        field: 'JobTitle',
        sortable: true,
        filter: true,
      },
      { headerName: 'City', field: 'City', sortable: true, filter: true },
      { headerName: 'Street Address', field: 'StreetAddress', sortable: true, filter: true },
      { headerName: 'Address 2', field: 'Address2', sortable: true, filter: true },
      { headerName: 'State', field: 'State', sortable: true, filter: true },
      { headerName: 'Country', field: 'Country', sortable: true, filter: true },
      { headerName: 'ZipCode', field: 'ZipCode', sortable: true, filter: true },
      {
        headerName: 'Contact Number',
        field: 'ContactNumber',
        sortable: true,
        filter: true,
      },
      { headerName: 'Notes', field: 'Notes', sortable: true, filter: true },
    ];

    this.invoiceColumns = [
      { headerName: 'Client', field: 'Client' },
      { headerName: 'Invoice Number', field: 'InvoiceNumber' },
      { headerName: 'Invoice Date', field: 'InvoiceDate' },
      { headerName: 'Amount', field: 'Amount' },
      { headerName: 'Paid', field: 'Paid' },
      { headerName: 'DueDate', field: 'DueDate', sortable: true, filter: true },
      {
        headerName: 'ItemProduct',
        field: 'ItemProduct',
        sortable: true,
        filter: true,
      },
      { headerName: 'ItemNotes', field: 'ItemNotes' },
      { headerName: 'ItemCost', field: 'ItemCost' },
      { headerName: 'ItemQuantity', field: 'ItemQuantity' },
      {
        headerName: 'Validation Errors',
        field: 'Warnings',
        cellRenderer: this.warningRenderer.bind(this),
      },
    ];
  }

  ngOnInit() {
    switch (this.type) {
      case 'item':
        this.columns = this.itemColumns;
        this.importTypeHeader = 'Products';
        break;
      case 'customer':
        this.columns = this.customerColumns;
        this.importTypeHeader = 'Customers';
        break;
      case 'invoice':
        this.columns = this.invoiceColumns;
        this.importTypeHeader = 'Invoices';
        break;
    }
    //this.loadLibraries();
  }

  private warningRenderer(params) {
    const self = this;

    if (params.data.HasMissingField) {
      const self = this;
      const eDiv = document.createElement('div');

      let template = `
      <div class="actions">
        <a class="action-item view-warnings" href="javascript:void(0)"><small style="color:#CE1025;">View Errors</small></a>
      </div>`;
      eDiv.innerHTML = template;

      var editBtn = eDiv.querySelectorAll('.view-warnings')[0];
      editBtn.addEventListener('click', () => {
        self.viewWarnings(params, self);
        //self.editInvoice(params, self);
      });

      return eDiv;
    }

    return '';
  }

  viewWarnings(param, self) {
    var warnings = param.data.Warnings;
    var errorMessage = '';
    for (var i = 0; i < warnings.length; i++) {
      errorMessage += '<span>' + warnings[i] + '</span><br/>';
    }
    this.alert.alertError({ title: 'Validation Errors', html: errorMessage });
  }

  step() {
    this.uploadStep = this.uploadStep == 1 ? 2 : 1;
  }

  onCsvFileSelected(event: any) {
    this.processingFile = true;
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setDomLayout('autoHeight');
  }

  gridRowStyle(params) {
    if (params.data.HasMissingField) {
      return { background: '#ffc107 !important' };
    }
    if (params.data.Existing) {
      return { background: '#dc3545 !important' };
    }
  }

  private validationRenderer(params) {
    const eDiv = document.createElement('div');
    let template = '';
    if (params.data.HasMissingField) {
      template =
        '<span class="text-danger" style="font-size:11px"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i>&nbsp;' +
        params.data.MissingFieldText +
        '</span>';
    } else {
      template =
        '<span class="text-success" style="font-size:11px"><i class="fa fa-check-circle" aria-hidden="true"></i></span>';
    }
    eDiv.innerHTML = template;

    return eDiv;
  }

  upload() {
    let alertText =
      this.uploadType === 2
        ? 'This will overwrite existing records. All items will be deleted and replaced. '
        : 'This will add new records and update existing ones. Existing records will be revised, not deleted.';
    let self = this;
    this.alert
      .alertQuestion({
        title: 'Import Confirmation',
        text: alertText + ' Would you like to proceed?',
        showCancelButton: true,
        showConfirmButton: true,
        cancelButtonClass: 'btn btn-lg btn-danger ml-2',
        confirmButtonText: 'Confirm',
      })
      .then((arg: any) => {
        if (arg.value) {
          let csvImportUpload = new CsvImportUpload();

          csvImportUpload.Items = self.itemsDataSource;
          csvImportUpload.Overwrite = self.uploadType === 2;
          self.busy = true;
          self.csvImportService
            .upload(csvImportUpload, self.type)
            .subscribe((res) => {
              self.activeModal.close(res);
              self.alert.alertSuccess({
                title: 'Success',
                text: 'Successfully initiated import queue!',
              });
            });
        }
      });
  }

  close() {
    this.activeModal.close();
  }
}
